import toCamelCase from './toCamelCase';

export default function getSite () {
	return process.env.NODE_ENV === 'development'
		? 'modulrFinanceLtd'
		: toCamelCase(location.pathname.split('/')[1]);
}
